import * as React from "react"

const CONFIG_TABLE_REPORT: Array<ColumnConfigType> = [
    {
        keystone: "Nome",
        label: "Categoria",
    },
    {
        keystone: "TotalQuestoes",
        label: "Total",
    },
    {
        keystone: "TotalAcertos",
        label: "Acertos",
    },
    {
        keystone: "Resultado",
        label: "Porcentagem",
        className: "",
        formatter: (Resultado: number) => `${(Math.round(Resultado * 100))}%`
    },
]


export default CONFIG_TABLE_REPORT